import React from 'react'

export interface IProvider<T> {
    context: T
    children: React.ReactNode | React.ReactNodeArray
}

export const generateContext = <T extends object>(): [
    React.Context<T>,
    ({ context, children }: IProvider<T>) => React.ReactElement
] => {
    const Context = React.createContext({} as T)
    const Provider = ({ context, children }: IProvider<T>) =>
        React.createElement(Context.Provider, { value: context }, children)
    return [Context, Provider]
}
